import React from 'react';
import { getSolicitationInfoPdf } from '../../../utils/fileDownload';

export const columns = [
  {
    Header: 'Solicitation ID',
    accessor: 'id',
    Cell: cellProps => (
      <span>
        <a href="#" onClick={() => { getSolicitationInfoPdf(`${cellProps.value}`) }} > {cellProps.value} </a>
      </span>
    ),
  },
  {
    Header: 'Casting Type',
    accessor: 'castingType',
  },
  {
    Header: 'NSN',
    accessor: 'purchaseRequest.nsnPart',
  },
  {
    Header: 'Nomenclature',
    accessor: 'purchaseRequest.nomenclature',
    width: 200,
  },

  {
    Header: 'Date Issued',
    accessor: 'issueDate',
  },
  {
    Header: 'Purchase Req #',
    accessor: 'purchaseRequest.number',
  },
  {
    Header: 'Quantity',
    accessor: 'purchaseRequest.quantity',
  },
  {
    Header: 'UI',
    accessor: 'um',
    width: 50,
  },
  {
    Header: 'SRVA',
    accessor: 'srva',
    width: 75,
  },
  {
    Header: 'SetAside',
    accessor: 'setAside',
    width: 75,
  },
  {
    id: 'material',
    Header: 'Materials / Methods',
    accessor: 'materialsMethods',
    Cell: cellProps => {
      console.log(cellProps);
      const arr = [];
      cellProps.value.forEach(element => {
        arr.push(
          <div>
            {element.material} / {element.method}
          </div>,
        );
      });
      return arr;
    },
    width: 240,
  },
];

export default {
  columns,
};



// WEBPACK FOOTER //
// ./src/components/grids/InformationGrid/gridConfig.jsx